import axios from "axios";


const GetDesignationList = async () => {
  return axios.get(`Designation/GetDesignations`).then((response) => response);
};


const AddDesignation = async (payload) => {
  const config = {
    method: "post",
    url: `Designation/AddDesignation`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};

const UpdateDesignation = async (payload) => {
  const config = {
    method: "post",
    url: `Designation/UpdateDesignation`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};

const designationService = {
  GetDesignationList,
  AddDesignation,
  UpdateDesignation,
};

export default designationService;
